import { createSlotRecipe } from './runtime';

const fieldConfig = {"name":"field","slots":["root","errorText","helperText","input","label","select","textarea"]}

export const field = /* @__PURE__ */ createSlotRecipe(fieldConfig)